import { useEffect, useRef } from "react";

function parseQueryString(qstr) {
	const pairs = qstr.split("&");
	const obj = {};
	pairs.forEach((pair) => {
		const [k, v] = pair.split("=");
		if (k) {
			try {
				obj[k] = decodeURIComponent(v || "");
			} catch {
				obj[k] = v || "";
			}
		}
	});
	return obj;
}

export default function ReviewFormAndIframe({ live, token, handleSuccess }) {
	const formRef = useRef(null);
	const iframeRef = useRef(null);

	useEffect(() => {
		// Define the global handler that communicator will call
		window.AuthorizeNetIFrame = window.AuthorizeNetIFrame || {};
		window.AuthorizeNetIFrame.onReceiveCommunication = function (querystr) {
			// querystr is something like "action=resizeWindow&width=700&height=600"
			let params = parseQueryString(querystr);
			// Sometimes response is a JSON string, e.g. response={"foo":"bar"}
			if (params.response) {
				// Try JSON parse
				try {
					params.response = JSON.parse(params.response);
				} catch (err) {
					console.warn("Could not parse response JSON:", err);
				}
			}

			const action = params.action;
			if (!action) {
				console.warn("No action in communicator message:", params);
				return;
			}

			switch (action) {
				case "resizeWindow": {
					const width = parseInt(params.width, 10) || null;
					const height = parseInt(params.height, 10) || null;
					if (iframeRef.current) {
						if (width) iframeRef.current.style.width = `${width}px`;
						if (height) iframeRef.current.style.height = `${height}px`;
					}
					break;
				}
				case "cancel": {
					console.log("Payment cancelled by user");
					break;
				}
				case "successfulSave": {
					console.log("Transaction response:", params.response);
					handleSuccess();
					break;
				}
				case "transactResponse": {
					console.log("Transaction response:", params.response);
					handleSuccess();
					break;
				}
				default:
					console.warn("Unknown action from communicator:", action, params);
			}
		};

		return () => {
			// Clean up when unmounting
			if (window.AuthorizeNetIFrame) {
				delete window.AuthorizeNetIFrame.onReceiveCommunication;
			}
		};
	}, []);

	useEffect(() => {
		if (formRef.current) {
			formRef.current.submit();
		}
	}, []);

	return (
		<>
			<form
				ref={formRef}
				action={
					live
						? "https://accept.authorize.net/customer/addPayment"
						: "https://test.authorize.net/customer/addPayment"
				}
				method="POST"
				target="resultFrame"
				style={{ display: "none" }}
			>
				<input type="hidden" name="token" value={token} />
			</form>

			<iframe
				ref={iframeRef}
				name="resultFrame"
				title="Post Result"
				style={{
					marginTop: "25px",
					width: "100%",
					height: "550px",
					border: "1px solid #ddd",
				}}
			/>
		</>
	);
}
